<template>
  <div class="webon-table-wrapper" :class="{ shrink: shrinkTable }">
    <div class="table-toolbar">
      <div class="section-toolbar" v-if="showToolbar">
        <div class="container decentered">
          <div class="row" style="height: 50px">
            <div
              v-if="!expandedExternalToolbar"
              class="toolbar-item col-sm-4 col-md-6"
              style="height: 100%"
            >
              <slot name="toolbar-start"></slot>
              <div class="input-search input-search-dark" v-if="allowSearch">
                <i
                  class="input-search-icon fas fa fa-search"
                  aria-hidden="true"
                ></i>
                <input
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  @keyup="onSearchChanged($event)"
                  placeholder="Buscar..."
                />
              </div>
              <div
                class="advanced-search"
                @click.stop="$emit('onAdvancedSearch')"
                v-show="!draggin && !forceSingleView"
                v-if="advancedSearch"
              >
                <img
                  class="advanced-search-icon"
                  title="Busqueda Avanzada"
                  alt="Busqueda avanzada"
                  v-tooltip="'Búsqueda avanzada'"
                  :src="`${iconsPath}ic-advanced-search.png`"
                />
              </div>
            </div>
            <div
              class="toolbar-item"
              :class="{
                'col-sm-8 col-md-6': !expandedExternalToolbar,
                'col-sm-12': expandedExternalToolbar,
              }"
              style="height: 100%"
            >
              <div class="outside-toolbar">
                <slot name="toolbar"></slot>
              </div>
              <div class="btn-group toolbar__actions">
                <button
                  class="btn btn-default"
                  :disabled="forceSingleView"
                  v-if="cardView"
                  @click.stop="onChangeView"
                >
                  <i class="fa fa-id-card"></i>
                </button>
                <button
                  class="btn btn-default btn-dropdown"
                  v-if="switchable && totalSwitchableItems > 0"
                  @click.stop="onToggleColumnsList()"
                >
                  <div class="dropdown-options">
                    <i class="fa fa-list"></i>
                    <i class="fa fa-caret-down"></i>
                  </div>
                  <div
                    class="dropdown-list"
                    v-show="dropOptionListDisplayed"
                    v-click-outside="onOptionsCloseList"
                  >
                    <div
                      class="dropdown-item"
                      v-for="header in headers"
                      :key="header.field"
                    >
                      <div
                        class="checkbox checkbox-custom checkbox-primary"
                        v-if="header.switchable"
                      >
                        <input
                          type="checkbox"
                          v-on:change="changeVisibility(header)"
                          :checked="!header.hidden"
                        />
                        <label @click.stop="changeVisibility(header)">{{
                          header.title
                        }}</label>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="toolbar table-container panel panel-body"
      :style="inModal ? 'height : auto;' : ''"
      :class="webonTableClass"
    >
      <template v-if="!loading && !isLoading">
        <!--TABLE VIEW-->
        <span v-if="topLegend" style="font-weight: 400">{{ topLegend }}</span>
        <table
          class="table table-hover bordered"
          :id="tableId"
          v-if="activeView == 'table'"
        >
          <wt-header
            :store-name="moduleName"
            :is-selectable="checkbox"
            :is-sort-enabled="sort"
            :headers="visibleHeaders"
            @onSort="$emit('onSort')"
            :data="data"
          />

          <wt-body
            v-if="!draggin"
            :is-selectable="checkbox"
            :store-name="moduleName"
            :headers="visibleHeaders"
            :checkbox-validation-callback="checkboxValidation"
            :isSingleSelectionMode="isSingleSelection"
            :click-to-select="clickToSelect"
            @onRowClicked="(row) => $emit('onRowClicked', row)"
            :data="data"
            :customMessage="customMessage"
          />

          <wt-draggable-body
            v-if="draggin"
            :is-selectable="checkbox"
            :store-name="moduleName"
            :headers="visibleHeaders"
            :checkbox-validation-callback="checkboxValidation"
            :isSingleSelectionMode="isSingleSelection"
            :click-to-select="clickToSelect"
            @onRowClicked="(row) => $emit('onRowClicked', row)"
            :data="dragginData"
          />
        </table>
        <!--TABLE VIEW-->

        <!--SINGLE ROW VIEW-->
        <div class="table" v-if="activeView == 'single-row' && !customCardView">
          <div
            class="single-row"
            v-for="(row, i) in data"
            :key="i"
            @click.stop="onRowClicked(row)"
            :class="{ 'selected-row': isRowSelected(row) }"
          >
            <div class="single-column" v-if="checkbox">
              <div>
                <span class="title">
                  <div
                    class="checkbox checkbox-custom checkbox-primary"
                    @click.stop="onSelectRow(row)"
                  >
                    <input
                      :checked="isRowSelected(row)"
                      type="checkbox"
                      :disabled="isDisabled(row)"
                    />
                    <label></label>
                  </div>
                </span>
              </div>
            </div>
            <div
              class="single-column"
              v-for="(header, i) in visibleHeaders"
              :key="i"
            >
              <div v-if="!header.formatter && !header.buttons">
                <span class="title">{{ header.title }}</span>
                <span class="content">{{
                  row[header.field] == "" || row[header.field] == null
                    ? emptyCellValue
                    : row[header.field]
                }}</span>
              </div>
              <div
                class="td-content"
                v-if="header.buttons && !header.formatter"
              >
                <div
                  v-for="(button, i) in header.buttons"
                  class="external-btn"
                  :key="i"
                  @click.stop="$emit(button.eventName, row)"
                >
                  <div v-html="button.content" v-if="!button.tooltip"></div>
                  <div
                    v-html="button.content"
                    v-if="button.tooltip"
                    v-tooltip="
                      '' + typeof button.tooltip === 'function'
                        ? button.tooltip(row)
                        : button.tooltip
                    "
                  ></div>
                </div>
              </div>
              <div v-if="header.formatter && !header.buttons">
                <span class="title">{{ header.title }}</span>
                <span
                  class="content"
                  v-html="header.formatter(row, row[header.field])"
                ></span>
              </div>
            </div>
          </div>
          <div class="empty-single-row-view" v-if="data.length == 0">
            No se encontraron registros
          </div>
        </div>
        <!--SINGLE ROW VIEW-->

        <!--SINGLE ROW VIEW (CUSTOM)-->
        <component
          class="table"
          v-if="activeView == 'single-row' && customCardView"
          v-bind:is="customCardView"
          :module-source="moduleName"
        />
        <!--SINGLE ROW VIEW (CUSTOM)-->

        <div
          class="table-pagination"
          v-if="totalData > 0 && pagination && !notPaginate"
        >
          <div class="page-configuration" v-if="showPagesConfiguration">
            <span
              >Mostrando {{ recordsDisplayedFrom }} a
              {{ recordsDisplayedTo }} de {{ totalData }} filas</span
            >
            <dep-select2
              :options="modalWrapper ? { wrapper: modalWrapper } : {}"
              v-if="totalData > 10"
              @change="onChangePageSize($event)"
              :opts="pageSizeOptions"
              :select-value="activePageSize"
              style="width: 50px; margin: 0 5px"
            ></dep-select2>
            <span v-if="totalData > 10">registros por página</span>
          </div>
          <div class="pages">
            <ul class="pagination-panel" v-if="!hidePagination">
              <li
                class="btn-pagination btn-pagination-arrow"
                @click.stop="changePage(-1)"
              >
                ‹
              </li>

              <li
                class="btn-pagination"
                :class="{ active: activePage == page }"
                v-for="(page, i) in paginationPages"
                :key="i"
                @click.stop="changeToPage(page)"
              >
                {{ page }}
              </li>

              <li
                class="btn-pagination btn-pagination-arrow"
                @click.stop="changePage(+1)"
              >
                ›
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="loading-data">
          Cargando...
          <div class="loader loader-circle"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ClickOutside from "v-click-outside";
import DepSelect2 from "../../ui/DepSelect2";

import WtHeader from "./components/WTHeader";
import WtBody from "./components/WTBody";
import WtDraggableBody from "./components/WTDraggableBody";

import DepClassesCardView from "./customCardViews/DepClassesCardView";
import DepClassesWizard from "./customCardViews/DepClassesWizard";

import draggable from "vuedraggable";

import STORAGE_NAMES from "@/lib/storage_names";
import {
  SET_STORAGE_NAME_FILTERS,
  WT_UPDATE_DRAW,
} from "@/vuex/mutation-types";

export default {
  components: {
    DepSelect2,
    draggable,
    //Custom Card Views (temporal, frankie method)
    DepClassesCardView,
    DepClassesWizard,

    // WebonTable Components
    WtHeader,
    WtBody,
    WtDraggableBody,
  },
  props: {
    tableId: { type: String, default: "WebonTable" },
    moduleName: { default: "webonTable" },
    localData: { defualt: null },
    columnsDefinition: { default: null },
    url: { default: null, type: String },
    type: { default: "post" },
    externalParameters: { default: null },
    searchOnEnter: { type: Boolean, default: true },
    sort: { type: Boolean, default: true },
    emptyCellValue: { default: "-" },
    checkbox: { type: Boolean, default: true },
    clickToSelect: { type: Boolean, default: false },
    ajax: { type: Boolean, default: true },
    customCardView: { default: false },
    switchable: { default: true },
    cardView: { default: true },
    allowSearch: { default: true },
    advancedSearch: { default: true },
    draggin: { default: false },
    forceSingleView: { default: false },
    defaultSort: { default: null },
    showToolbar: { default: true },
    defaultPageSize: { default: 50 },
    showPagesConfiguration: { default: true },
    pagination: { default: true },
    tableWrapperClass: { default: "" },
    inModal: { default: false },
    customDefaultFilters: { default: false },
    initialSelection: { default: null },
    notPaginate: { default: false },
    keepSelection: { default: false },
    modalWrapper: { default: null },
    selectAllData: { default: false },
    checkboxValidation: { default: null },
    topLegend: { default: null },
    isSingleSelection: { default: false },
    tooltip: { default: null },
    disabledRequest: { default: false },
    shrinkTable: { type: Boolean, default: false },
    isLoading: { default: false },
    expandedExternalToolbar: { type: Boolean, default: false },
    customMessage: {
      type: String,
      default: null,
    },
    filterData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    event() {
      this.$emit(this.event.name, this.event.payload);
    },
    disabledRequest() {
      this.$store.dispatch(
        `${this.storeAddress}/updateDisabledRequestState`,
        this.disabledRequest
      );
    },
    externalParameters(newFilters) {
      if (this.filterDataTimer) clearTimeout(this.filterDataTimer);

      if (
        JSON.stringify(newFilters) ==
        JSON.stringify(this.finalExternalParameters)
      )
        return;

      this.filterDataTimer = setTimeout(() => {
        this.finalExternalParameters = this.externalParameters;
        this.$store.dispatch(
          `${this.storeAddress}/updateParameters`,
          this.finalExternalParameters
        );
      }, 500);
    },
    url() {
      this.$store.dispatch(`${this.storeAddress}/updateUrl`, this.url);
    },
    forceSingleView() {
      if (this.forceSingleView) {
        this.activeView = "single-row";
        this.customCardComponent().then(() => {});
      } else {
        this.activeView = "table";
      }
    },
    customCardView() {
      if (this.activeView == "single-row")
        this.customCardComponent().then(() => {});
    },
    async localData() {
      this.$store.dispatch(`${this.storeAddress}/resetSelection`);
      this.$store
        .dispatch(`${this.storeAddress}/getData`, this.localData)
        .then(() => {});
      this.$store.dispatch(`${this.storeAddress}/refreshData`);
    },
  },
  data() {
    return {
      pageSizeOptions: [
        { id: 10, text: 10 },
        { id: 25, text: 25 },
        { id: 50, text: 50 },
        { id: 100, text: 100 },
      ],

      dropOptionListDisplayed: false,
      searchKey: "",

      //Views controls
      activeView: "table",

      filterDataTimer: null,

      finalExternalParameters: null,

      iconsPath: "/img/icons/",
    };
  },
  mounted() {
    this.$store.dispatch(
      `${this.storeAddress}/updateDisabledRequestState`,
      this.disabledRequest
    );
    const fields = this.$storage(
      STORAGE_NAMES.SPA_CONFIG +
        "." +
        this.moduleName +
        "." +
        STORAGE_NAMES.TABLE_STORAGE +
        "_FIELDS"
    );
    if (fields && fields.length && this.columnsDefinition.length) {
      for (let i = 0; i < fields.length; i++) {
        const f = fields[i];
        const header = this.columnsDefinition.find((h) => {
          return h.title == f.title && h.switchable;
        });
        if (header) {
          header.hidden = f.hidden || false;
        }
      }
    }
    if (this.defaultPageSize < this.pageSizeOptions[0].id) {
      this.pageSizeOptions.unshift({
        id: this.defaultPageSize,
        text: this.defaultPageSize,
      });
    }
    this.loadTable();
    this.$store.commit(
      this.moduleName.replace(/\./gi, "/") +
        "/table/" +
        SET_STORAGE_NAME_FILTERS,
      this.moduleName
    );
  },
  computed: {
    event() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .event;
    },
    webonTableClass() {
      return (
        this.tableWrapperClass + (!this.inModal ? " scrolleable-wrapper " : "")
      );
    },
    totalSwitchableItems() {
      return this.columnsDefinition.filter((el) => {
        return el.switchable === true;
      }).length;
    },
    loading() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .loading;
    },
    customCardComponent() {
      let _customComponent = this.customCardView;
      return () => import(`./customCardViews/${_customComponent}.vue`);
    },
    storeAddress() {
      return this.moduleName.replace(/\./g, "/") + "/table";
    },
    totalData() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .totalRows;
    },
    data() {
      const { data } = this.$propertyByString(
        this.$store.state,
        this.moduleName
      ).table;

      const tableData = Array.from(data);

      if (!this.ajax) {
        if (!this.notPaginate) {
          const startIndex = this.activePageSize * (this.activePage - 1);
          return tableData.slice(startIndex, startIndex + this.activePageSize);
        }
        return tableData;
      }

      if (this.filterData) {
        return tableData.filter((item) =>
          Object.entries(this.filterData).every(
            ([key, value]) => item[key] === value
          )
        );
      }

      return tableData;
    },
    activePageSize() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .currentPageSize;
    },
    activePage() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .currentPage;
    },
    pages() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .totalPages;
    },
    headers() {
      if (!this.columnsDefinition) return [];

      return this.columnsDefinition;
    },
    visibleHeaders() {
      return this.headers.filter((el) => {
        return el.hidden === false || !el.hidden;
      });
    },
    paginationPages() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .paginationPages;
    },
    recordsDisplayedFrom() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .legendDisplayingFrom;
    },
    recordsDisplayedTo() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .legendDisplayingTo;
    },
    hidePagination() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .hidePagination;
    },
    sorting() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .sortParams;
    },
    selectedRows() {
      return this.$propertyByString(this.$store.state, this.moduleName).table
        .selection;
    },
    dragginData: {
      get() {
        return this.$propertyByString(this.$store.state, this.moduleName).table
          .drawData;
      },
      set(newList) {
        this.$store.commit(
          this.moduleName.replace(/\./g, "/") + "/table/" + WT_UPDATE_DRAW,
          newList
        );
        this.$emit("onDraggedItem");
      },
    },
    isAllSelected() {
      let _dataInSelection = this.data.filter((el) => {
        return this.selectedRows
          .map((el) => JSON.stringify(el))
          .includes(JSON.stringify(el));
      });
      return (
        _dataInSelection.length == this.data.length && this.data.length > 0
      );
    },
  },
  methods: {
    changeVisibility(header) {
      header.hidden = !header.hidden;
      this.$storage(
        STORAGE_NAMES.SPA_CONFIG +
          "." +
          this.moduleName +
          "." +
          STORAGE_NAMES.TABLE_STORAGE +
          "_FIELDS",
        this.headers
      );
    },
    async loadTable() {
      this.finalExternalParameters = this.externalParameters;

      this.$store
        .dispatch(`${this.storeAddress}/initializeProperties`, {
          baseUrl: this.url,
          ajax: this.ajax,
          type: this.type,
          externalParameters: this.finalExternalParameters,
          allowSort: true,
          currentPageSize: this.defaultPageSize,
          customFilters: this.customDefaultFilters,
          initialSelection: this.initialSelection,
          keepSelection: this.keepSelection,
          columnsDefinition: this.columnsDefinition,
        })
        .then(() => {
          this.$store.dispatch(`${this.storeAddress}/getData`, this.localData);
        })
        .catch(() => {});
    },
    changePage(step) {
      let _newPage = this.activePage + step;

      if (_newPage <= 0) return;
      if (_newPage > this.pages) return;

      this.$store.dispatch(this.storeAddress + "/changePage", _newPage);
      this.$emit("onChangePage");
    },
    changeToPage(page) {
      if (page == "..." || this.activePage == page) return;

      this.$store.dispatch(this.storeAddress + "/changePage", page);
      this.$emit("onChangePage");
    },
    onChangePageSize(pageSize) {
      this.$emit("onChangePageSize");
      this.$store.dispatch(this.storeAddress + "/changePageSize", pageSize);
    },
    onSort(_key, isSortable) {
      if (!this.sort || isSortable === false) return;

      this.$store.dispatch(this.storeAddress + "/applySort", _key);
      this.$emit("onSort");
    },
    onSearchChanged(key) {
      if (this.searchOnEnter && key.keyCode == 13) {
        this.$store.dispatch(
          this.storeAddress + "/applySearch",
          this.searchKey
        );
      } else if (this.searchKey.length == 0) {
        this.$store.dispatch(
          this.storeAddress + "/applySearch",
          this.searchKey
        );
      }
    },
    onOptionsCloseList() {
      this.dropOptionListDisplayed = false;
    },
    onChangeView() {
      this.activeView = this.activeView == "table" ? "single-row" : "table";

      this.$emit("onViewChanged", this.activeView);

      if (this.activeView == "single-row" && this.customCardView) {
        this.customCardComponent().then(() => {});
      }
    },
    onSelectAllRows() {
      this.$store.dispatch(this.storeAddress + "/selectAllRows", this.data);
    },
    onSelectRow(row) {
      this.$store.dispatch(this.storeAddress + "/selectRow", {
        row,
        isSingleSelection: this.isSingleSelection,
      });
    },
    isRowSelected(row) {
      return (
        this.$propertyByString(
          this.$store.state,
          this.moduleName
        ).table.selection.findIndex((el) => {
          return JSON.stringify(el) == JSON.stringify(row);
        }) > -1
      );
    },
    onRowClicked(row) {
      if (this.clickToSelect && !this.isDisabled(row)) this.onSelectRow(row);

      this.$emit("onRowClicked", row);
    },
    onToggleColumnsList() {
      this.dropOptionListDisplayed = !this.dropOptionListDisplayed;
    },
    refreshData() {
      this.$store
        .dispatch(this.storeAddress + "/refreshData")
        .then(() => {})
        .catch(() => {});
    },
    isDisabled(row) {
      /** Método para deshabilitar el checkbox */
      if (this.checkboxValidation) {
        return this.checkboxValidation(row);
      }
      return false;
    },
  },
  directives: { clickOutside: ClickOutside.directive },
};
</script>

<style lang="scss">
.webon-table-wrapper {
  width: 100%;

  .table-toolbar {
    .section-toolbar {
      .toolbar-item {
        display: flex;
        align-items: center;
        padding: 0;

        .outside-toolbar {
          margin-right: 15px;
          .btn:not(.btn-excluded) {
            background: transparent !important;
            color: #579adc;
            border: 0.5px solid #579adc;

            display: flex;
            align-items: center;
            justify-content: center;

            min-width: 48px;
            min-height: 36px;

            &[disabled] {
              background: transparent !important;
              opacity: 1;
              color: #d5e6f6;
            }

            img {
              max-width: 14px;
              max-height: 28px;
              object-fit: contain;
            }

            &:hover {
              background: white;
            }
          }
        }

        .input-search {
          margin-right: 5px;
          input {
            height: 23.4px;
            width: 240px;
          }
        }

        .advanced-search {
          font-style: italic;
          cursor: pointer;

          .advanced-search-icon {
            width: 25px;
          }
        }

        &:last-child {
          justify-content: flex-end;
        }
      }
      .toolbar__actions {
        .btn {
          border: 1px solid #cbcbcb;
          background: transparent !important;
          color: #9b9b9b !important;
          &-dropdown {
            position: relative;
            .dropdown-options {
              i.fa:first-child {
                margin-right: 10px;
              }
            }
            .dropdown-list {
              position: absolute;
              margin-top: 3px;
              right: 0;
              background: #fff;
              min-width: 150px;
              padding: 5px;
              text-align: left;
              border-radius: 4px;
              z-index: 14;

              .dropdown-item {
                cursor: pointer;
                color: #3c3c3c !important;
                background: #fff;
                margin: 3px 0px;
                padding: 0px;
              }
            }
          }
        }
      }
    }
  }

  .table-container {
    padding: 21px 17px;

    .checkbox {
      margin: 0 !important;
      label::before {
        outline: none !important;
      }
    }

    .table {
      transform-style: preserve-3d;
      .external-btn {
        margin: 0 5px;
      }

      &.bordered {
        th {
          background: #e2e9f0;
          color: #696969;
          font-size: 14px;
          height: 35px;
        }
        th,
        td {
          border: 1px solid #cbcbcb !important;
          border-bottom: none !important;
          padding: 5px 7px !important;
        }
        td {
          font-size: 13px;
          border-top: none !important; /*
                    border-color : #dbdbdb !important; */

          div.td-content {
            min-height: 35px;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        tbody {
          tr:last-child {
            td {
              border-bottom: 1px solid #cbcbcb !important;
            }
          }
        }
      }

      thead {
        tr {
          th {
            .head-content {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              cursor: pointer;
              .sorting-columns {
                position: relative;
                height: 100%;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                i.fa {
                  color: #999;
                  &.active {
                    color: #7a80dd;
                  }
                  &.hidden {
                    opacity: 0;
                  }
                  &:first-child {
                    position: absolute;
                    margin-top: -6px;
                  }
                  &:last-child {
                    margin-top: 6px;
                  }
                }
              }
            }
          }
        }
      }

      tbody {
        max-height: 550px;
        overflow: auto;
        tr {
          &:nth-child(2n) {
            background: #f3f3f3;
          }

          &:hover {
            background: #f3f7f9;
          }

          td.empty-table {
            align-items: center;
            color: #76838f;
            font-size: 14px;
            text-align: center;
            padding-top: 10px;
          }

          &.selected-row {
            background: #e5e5e5;
          }
        }
      }

      .draggable-container {
        tr {
          cursor: move;
        }
      }

      //Single Row View
      .single-row {
        width: 100%;
        border: 1px solid #cbcbcb;
        border-bottom: 0px;
        padding: 10px;

        &:first-child {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }

        &:last-child {
          border-bottom: 1px solid #cbcbcb;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }

        .single-column {
          width: 100%;
          > div {
            width: 100%;
            display: flex;
          }
          .title {
            width: 20%;
            min-width: 150px;
            font-weight: bold;
          }
        }

        &:hover {
          background: #f3f7f9;
        }

        &.selected-row {
          background: #f5f5f5;
        }
      }

      .empty-single-row-view {
        width: 100%;
        border: 1px solid #cbcbcb;
        border-radius: 4px;
        padding: 10px;
        text-align: center;
      }
    }

    .table-pagination {
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 12px;
      .page-configuration {
        font-size: 14px;
        color: #76838f;

        display: flex;
        align-items: center;

        span {
          margin: 0 5px;
        }
      }
      .pages {
        ul.pagination-panel {
          display: flex;
          align-items: center;
          li {
            list-style: none;

            border: 1px solid #e4eaec;
            border-left: 0px;

            cursor: pointer;

            &:first-child {
              border-left: 1px solid #e4eaec;
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
            }

            &:last-child {
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
            }

            &:hover {
              color: #89bceb;
              border-color: #e4eaec;
              background: #f3f7f9;
            }

            &.active {
              color: white;
              cursor: default;
              border-color: #62a8ea;
              background: #62a8ea;
            }

            &.btn-pagination {
              width: 33.7px;
              height: 34px;
              display: flex;
              align-items: center;
              justify-content: center;

              &.btn-pagination-arrow {
                width: 30.1px;
              }
            }
          }
        }
      }
    }

    .loading-data {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 150px;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>

<style lang="scss">
.webon-table-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.shrink {
    height: auto !important;

    .table-container.scrolleable-wrapper {
      height: auto !important;
    }
  }

  .table-container {
    flex-grow: 2;
    margin-bottom: 10px;
  }

  .table {
    &.bordered {
      th {
        background: #e2e9f0;
        color: #696969;
        font-size: 14px;
        height: 35px;
      }
      th,
      td {
        border: 1px solid #cbcbcb !important;
        padding: 5px 7px !important;
      }
      td {
        font-size: 13px;
        div.td-content {
          min-height: 35px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    tbody {
      max-height: 550px;
      overflow: auto;
      tr {
        &:nth-child(2n) {
          background: #dcdcdc56;
        }

        &:hover {
          background: #f3f7f9;
        }

        td.empty-table {
          align-items: center;
          color: #76838f;
          font-size: 14px;
          text-align: center;
          padding-top: 10px;
        }

        &.selected-row {
          background: #e5e5e5;
        }
      }
    }
  }
}
.sortable-drag {
  width: 100%;
  display: flex;
}
</style>
